import {
  TypedUseSelectorHook,
  useSelector as reactUseSelector,
} from 'react-redux';
import { RootState } from '../store';

const useSelector: TypedUseSelectorHook<RootState> = reactUseSelector;

export default useSelector;
